import { useContext } from 'react'
import { Box } from '@n26/nxd'
import { Heading } from '@components/Heading'
import { ConfigContext } from '@contexts/ConfigContext'

export const ModuleErrorBoundary = () => {
  const config = useContext(ConfigContext)

  if (!config?.showModuleErrors) return null

  return (
    <Box className='border-rhubarb border-8' padding='24'>
      <Heading level={4}>Module Error</Heading>
    </Box>
  )
}
